export const ru = {
    'adjustments-rate':
        'Ставки показаны без учёта применяемых к ним корректировок',
    audience_coverage: 'Охват аудитории',
    'context-click-price': 'Цена клика в сетях',
    'context-price': 'Ставка (в сетях)',
    coverage: 'Охват',
    'cpm-banner-set-context-price': 'Назначить ставку за тысячу показов',
    'cpm-banner-title': 'Изменение ставки',
    'no-display-info':
        'У системы нет данных о показах этой фразы в сетях (РСЯ и внешние сети), поэтому спрогнозировать охват и стоимость клика невозможно. '
};
